export default {
  article: {
    title: 'USFans Spreadsheet : Le guide complet et le centre de ressources',
    quickAnswerLabel: 'Réponse rapide',
    quickAnswer: 'Le USFans Spreadsheet est une ressource unique et organisée qui regroupe les articles et vêtements de fans américains dans des catégories claires. Au lieu d\'ouvrir des dizaines d\'onglets ou de deviner où chercher, vous pouvez accéder directement aux chaussures, sweats, maillots et accessoires grâce à des liens directs, ce qui vous fait gagner du temps et garde votre navigation ordonnée.',
    intro: 'Que vous cherchiez un maillot précis, que vous parcouriez de nouvelles baskets ou que vous soyez simplement curieux de ce qui est disponible, le USFans Spreadsheet est conçu pour faciliter la découverte. Ce guide explique ce qu\'est le spreadsheet, ce que vous y trouverez, comment l\'utiliser et pourquoi c\'est un point de départ utile pour les fans comme pour les acheteurs.',
    secWhat: {
      title: 'Qu\'est-ce que le USFans Spreadsheet ?',
      p1: 'Le USFans Spreadsheet est un annuaire organisé par catégories d\'articles à thème américain. Il regroupe les types de produits les plus populaires — des chaussures et couvre-chefs aux accessoires et parfums — dans une structure simple et navigable. Plutôt qu\'une longue liste non structurée, le spreadsheet utilise des regroupements clairs pour que vous sachiez toujours où chercher.',
      p2: 'Considérez-le comme un point d\'entrée unique. Chaque catégorie possède son propre lien direct, ce qui signifie que vous pouvez passer de la page d\'accueil à une collection ciblée en un clic. L\'objectif est de réduire les frictions et de vous aider à trouver plus vite ce que vous voulez.',
    },
    secFind: {
      title: 'Ce que vous trouverez à l\'intérieur',
      p1: 'Le spreadsheet couvre une large gamme de catégories de vêtements et d\'accessoires, notamment :',
    },
    secHow: {
      title: 'Comment utiliser le USFans Spreadsheet',
      p1: 'Utiliser le spreadsheet est simple. Sur la page d\'accueil, choisissez une catégorie dans le menu déroulant ou touchez n\'importe quelle carte de catégorie. Vous serez redirigé directement vers la collection correspondante sur le site principal. Comme chaque catégorie possède un lien direct et dédié, vous évitez les allers-retours habituels de recherche et de filtrage.',
      p2: 'Pour l\'expérience la plus rapide, commencez par le menu déroulant lorsque vous savez exactement ce que vous voulez, et utilisez la grille lorsque vous préférez parcourir visuellement.',
    },
    secPopular: {
      title: 'Catégories populaires à explorer',
      p1: 'Certaines catégories sont particulièrement populaires auprès des visiteurs. Les chaussures sont un point de départ fréquent pour les fans de baskets, tandis que les sweats et hoodies restent un choix idéal pour un usage quotidien et confortable. Les maillots attirent les supporters sportifs, et les accessoires — des sacs aux ceintures — offrent des moyens rapides de compléter une tenue.',
      p2: 'Les parfums et les ensembles valent aussi la peine d\'être explorés si vous cherchez des idées de cadeaux ou un look coordonné. Chaque catégorie pointe vers une collection dédiée, pour que vous puissiez plonger dans le domaine qui vous intéresse le plus.',
    },
    secCompare: {
      title: 'USFans Spreadsheet vs. recherche manuelle',
      p1: 'Le tableau ci-dessous compare l\'utilisation du USFans Spreadsheet à la recherche manuelle sur plusieurs pages.',
      col1: 'USFans Spreadsheet',
      col2: 'Recherche manuelle',
      col3: 'Idéal pour',
      r1factor: 'Organisation',
      r1v1: 'Élevée — catégories claires',
      r1v2: 'Variable — selon l\'effort',
      r1best: 'Garder de l\'ordre',
      r2factor: 'Vitesse',
      r2v1: 'Rapide — liens directs',
      r2v2: 'Plus lent — plusieurs étapes',
      r2best: 'Accès rapide',
      r3factor: 'Cohérence',
      r3v1: 'Structure standardisée',
      r3v2: 'Incohérente',
      r3best: 'Visites répétées',
      r4factor: 'Courbe d\'apprentissage',
      r4v1: 'Faible',
      r4v2: 'Modérée',
      r4best: 'Débutants',
      r5factor: 'Mises à jour',
      r5v1: 'Faciles à actualiser',
      r5v2: 'Manuelles',
      r5best: 'Rester à jour',
    },
    secTips: {
      title: 'Conseils pour en tirer le meilleur parti',
      tip1: 'Commencez par la catégorie qui correspond à votre objectif : la recherche est plus rapide quand vous êtes précis.',
      tip2: 'Utilisez le menu déroulant pour des sauts rapides, et la grille pour un parcours visuel.',
      tip3: 'Ajoutez la page d\'accueil à vos favoris pour revenir à la ressource quand vous en avez besoin.',
      tip4: 'Revenez consulter les guides mis à jour et les nouvelles catégories.',
    },
    faq: {
      title: 'Questions fréquentes',
      q1: 'Qu\'est-ce que le USFans Spreadsheet ?',
      a1: 'C\'est un annuaire par catégories qui organise les articles et vêtements de fans américains dans une structure simple et navigable avec des liens directs vers chaque collection.',
      q2: 'La consultation du spreadsheet est-elle gratuite ?',
      a2: 'Oui. Parcourir les catégories et lire les guides de cette ressource est entièrement gratuit.',
      q3: 'Comment trouver une catégorie précise ?',
      a3: 'Utilisez le menu déroulant de la page d\'accueil pour accéder à une catégorie, ou touchez n\'importe quelle carte de catégorie dans la grille.',
      q4: 'Ai-je besoin d\'un compte pour l\'utiliser ?',
      a4: 'Aucun compte n\'est requis pour parcourir les catégories ou lire les guides.',
      q5: 'Où mènent les liens de catégorie ?',
      a5: 'Chaque lien de catégorie vous mène à la collection correspondante sur notre site principal, où vous pouvez consulter les produits de cette catégorie.',
    },
    related: {
      title: 'Continuez à explorer',
      text: 'Revenez à la page d\'accueil pour parcourir toutes les catégories, ou visitez le site principal directement.',
    },
    ctaButton: 'Visiter le site principal',
    backHome: 'Retour au centre USFans Spreadsheet',
    author: 'Équipe éditoriale USFans',
    published: 'Publié',
    updated: 'Mis à jour',
  },
};